import { lazy } from 'react'

import Categorie from './categorie'
import Permessi from './permessi'

export default {
    path: '/utenti',
    title: 'Utenti',
    authenticated: true,
    component: lazy(() => import('./filter')),
    pages: [
        {
            path: '/:utenteId',
            title: 'Utente: {{params.utenteId}}',
            drawer: false,
            component: lazy(() => import('./detail')),
            pages: [Categorie, Permessi]
        }
    ]
}